<template>
<div id="apptable" v-cloak>

    <b-card header="Soci" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-2">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-2">    
                    <b-form-select v-model="flgatt" :options="options_attivo" id="flgatt">
                        <template slot="first">
                            <option :value="null" selected>-- Seleziona stato --</option>
                        </template>    
                    </b-form-select>
                </div>                
                <div class="col-md-2">    
                    <b-form-select v-model="flgsocio" :options="options_profilo" id="flgsocio">
                        <template slot="first">
                            <option :value="null" selected>-- Seleziona profilo --</option>
                        </template>    
                    </b-form-select>
                </div>
                <div class="col-md-6 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>
                    <b-button style="margin:1px 0px 1px 2px;" v-show="!isVismenuZ()" size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>                                        
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                    <template slot="cognome" scope="row">{{row.value}}</template>
                    <template slot="nome" scope="row">{{row.value}}</template>
                    <template slot="account" scope="row">{{row.value}}</template>
                    <template slot="codfiscale" scope="row">{{row.value}}</template>
                    <template slot="email" scope="row">{{row.value}}</template>
                    <template slot="azienda" scope="row">{{row.value}}</template>
                    <template slot="profiloVis" scope="row">{{row.value}}</template>
                    <template slot="attivoVis" scope="row">{{row.value}}</template>
                    <!-- <template slot="ruoloVis" scope="row">{{row.value}}</template> -->

                    <template slot="modifica" scope="row">
                        <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                        <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                        <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                        <!-- <b-btn v-show="!isVismenuZ() && parametri != null && parametri.flgparenti == 'S'" style="margin:0px 0px 1px 2px;" variant="info" size="sm" @click.stop="parenti(row.item,row.index,$event.target)">Parenti</b-btn> -->
                    </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>
        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
    </b-card>
    
    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione del socio #{{deleteModal.id}}: {{deleteModal.titolo}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>
    
</div>
</template>

<script>

import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Socio
} from '../classes.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                cognome: {
                    label: 'Cognome',
                    sortable: true
                },
                nome: {
                    label: 'Nome',
                    sortable: true
                },
                account: {
                    label: 'N° Socio',
                    sortable: true
                },
                codfiscale: {
                    label: 'Codice fiscale',
                    sortable: true
                },
                email: {
                    label: 'Email',
                    sortable: true
                },
                azienda: {
                    label: 'Azienda',
                    sortable: true
                },
                profiloVis: {
                    label: 'Profilo',
                    sortable: true
                },
                attivoVis: {
                    label: 'Stato',
                    sortable: true
                },
                /*
                ruoloVis: {
                    label: 'Ruolo',
                    sortable: true
                },
                */
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            deleteModal: {
                id: null,
                titolo: '',
                show: false
            },
            parametri: null,
            flgatt: null,
            flgsocio: null,
            options_attivo:[],
            options_profilo:[],
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: this.$route.params.filter || null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false,
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    watch: {
        
        filter: function (newValue, oldValue) {             
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/soci/filter/${this.filter}/flgatt/${this.flgatt}/flgsocio/${this.flgsocio}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/soci/flgatt/${this.flgatt}/flgsocio/${this.flgsocio}`
                });
            }
        },
        flgatt: function (newValue, oldValue) {             
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/soci/filter/${this.filter}/flgatt/${this.flgatt}/flgsocio/${this.flgsocio}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/soci/flgatt/${this.flgatt}/flgsocio/${this.flgsocio}`
                });
            }          
            this.refreshData();            
        },
        flgsocio: function (newValue, oldValue) {             
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/soci/filter/${this.filter}/flgatt/${this.flgatt}/flgsocio/${this.flgsocio}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/soci/flgatt/${this.flgatt}/flgsocio/${this.flgsocio}`
                });
            }          
            this.refreshData();          
        }
        
    },
    methods: {
        isVismenuZ(){
            //console.log("ctrlVismenu(Z): " + ctrlVismenu("Z"))
            return ctrlVismenu("Z");
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.titolo = item.cognome + " " + item.nome;
            this.deleteModal.show = true;
        },
        exportCSV() {
            if (this.items.length > 0) {

                var str = '"#";"Cognome";"Nome";"N° Socio";"Codice fiscale";"Email";';
                str += '"Azienda";"Profilo";"Stato";"SSO";"Cellulare";"Indirizzo";"Sede";"Ruolo";"Data inserimento"\r\n';
                for (var i = 0; i < this.items.length; i++) {                       
                    str += '"' + this.items[i].id + '"' + ";";
                    str += '"' + this.items[i].cognome.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].nome.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].account.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].codfiscale.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].email.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].azienda.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].profiloVis.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].attivoVis.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].sso.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].cell.replace(/"/g, '\'') + '"' + ";";
                    str += '"' + this.items[i].indirizzo.replace(/"/g, '\'') + '"' + ";";
                    
                    str += '"' + this.items[i].sede.replace(/"/g, '\'') + '"' + ";";                    
                    str += '"' + this.items[i].ruoloVis.replace(/"/g, '\'') + '"' + ";";   

                    str += '"' + this.items[i].datins.replace(/"/g, '\'')  + '"' + "\r\n";
                }

                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                a.download = 'soci_' + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                    document.body.removeChild(a);
                }, 100);
            }
        },
        getFlgsoci() {

            var sc = new Socio();
            var tipi = sc.getListaFlgatt();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

        },
        getProfili() {

            var sc = new Socio();
            var tipi = sc.getListaProfili();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

        },
        insert() {
            this.$router.push('/app/dettagliosocio');
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettagliosocio/${item.id}`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        parenti(item, index, button) {

            this.$router.push({
               path: `/app/parenti/id_socio/${item.id}`
            });

        },
        refreshData() {
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/soci/flgatt/' + this.flgatt + '/flgsocio/' + this.flgsocio, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.items = response.data.message;
                            let apptable = this;

                            var socio = new Socio();
                            apptable.items.forEach(function(element, index) {
                                element.ruoloVis = socio.getRuoloByFlag(element.flgruolo);

                                //element.attivoVis = (element.flgatt == 'S' ? 'Sì' : 'No');
                                element.attivoVis =  socio.getFlgattByFlag(element.flgatt);

                                element.profiloVis = socio.getProfiloByFlag(element.flgsocio);
                                //element.socioVis = (element.flgsocio == 'S' ? 'Sì' : 'No');
                                if (element.flgatt == 'N') { //non attivo
                                    element._rowVariant = 'danger';
                                }
                                else if (element.flgatt == 'I') { //da confermare
                                    element._rowVariant = 'warning';
                                }
                                delete element.uteins; //per motivi di ricerca
                            });

                            this.showtable = true;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

                //PAREMETRI
                token = localStorage.getItem('token');
                var appdettaglio = this;

                this.axios.get(NAMESPACE + 'rest/cral', {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;

                                if (typeof res == "object") {

                                    appdettaglio.parametri = res;

                                } else {
                                    throw new Error("Errore parametri non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
        },
        delItem() {

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/soci/' + this.deleteModal.id, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {
                    if (!response.data.error) {
                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        //forse può essere fatta diversamente e meglio
                        for (var i = 0; i < this.items.length; i++) {
                            if (this.items[i].id == this.deleteModal.id) {
                                this.items.splice(i, 1); //delete
                                break;
                            }
                        }
                        this.deleteModal.show = false;

                    } else {
                        throw new Error(response.data.message);
                    }
                } catch (e) {
                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }
            })
            .catch(e => {
                this.deleteModal.show = false;
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });
         

        },
    },
    created: function () {

        if(!ctrlVismenu("S")&&!ctrlVismenu("Z")){
            this.$router.replace('/accessdenied');
            return;
        }

        this.options_attivo = this.getFlgsoci();
        this.options_profilo = this.getProfili();



        this.refreshData();        

    }
}
</script>
